import { useContext } from "react";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import cn from "classnames";

import { Button as CommonButton, ButtonProps } from "capitalrx-components-2.0/lib/general";

import { ThemeSelectorContext } from "@/basic/context";

import styles from "../styles.module.scss";

interface BackButtonProps extends ButtonProps {
  path: string;
  params: string;
}

export const BackButton = ({ path, params }: BackButtonProps) => {
  const { t: translate } = useTranslation();
  const navigate = useNavigate();
  const { client } = useContext(ThemeSelectorContext);

  const handleOnclick = () => {
    navigate({
      pathname: path,
      search: params,
    });
  };

  const backButtonClass = cn(
    { [styles["ButtonText"]]: !!client },
    { [styles["ButtonWhiteText"]]: !client },
  );

  return (
    <CommonButton onClick={handleOnclick} icon="chevron-left" size="small" appearance="text" className={backButtonClass}>
      {translate("BUTTONS.backButton.back")}
    </CommonButton>
  );
};
